import ProtectiveSolutionsPage from "./protective-solutions.page"

export default ProtectiveSolutionsPage;
